import {useJbiCourseDetailsQuery} from 'src/generated/graphql';
import {JbiEnhancedLectureVariant} from 'src/lib/experimentation-constants';
import {JbiCourseDetailsData} from 'src/types/page-props';

/**
 * Fetches course-level detail (rating, enrollment count, learning outcomes, curriculum
 * sections) for the single course shown in the JBI unit. Scoped to one course and gated on a
 * non-control variant so control users and the other 7 fetched enrollments never trigger
 * this fetch.
 */
export function useJbiCourseDetails(
    courseId: string | undefined,
    variant: JbiEnhancedLectureVariant | undefined,
): {data: JbiCourseDetailsData; isLoading: boolean} {
    const isJbiV2Variant = variant !== undefined && variant !== 'control';
    const shouldFetch = Boolean(courseId) && isJbiV2Variant;

    const {data, isLoading} = useJbiCourseDetailsQuery(
        {courseId: courseId ?? ''},
        {enabled: shouldFetch},
    );

    return {
        data: data?.course ?? null,
        isLoading: shouldFetch && isLoading,
    };
}
